module.exports = __webpack_public_path__ + "img/logoasefor.36d6b5ab.png";